/* Rounded progress bar shown at the bottom of the mini player card. */

interface MiniPlayerProgressBarProps {
  currentTime: number;
  duration: number;
}

export function MiniPlayerProgressBar({ currentTime, duration }: MiniPlayerProgressBarProps) {
  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;

  return (
    <div className="h-1 rounded-full bg-muted">
      <div
        className="h-full rounded-full bg-primary transition-[width] duration-200 ease-linear"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
